module.exports = __webpack_public_path__ + "static/media/bt.927ecffd.svg";